import React from 'react';
import { Card, CardActions, CardContent, Button, Typography, Box } from '@material-ui/core';
import IconHolder from '../IconHolder';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import './CardVertical.scss';

export default function CardVertical(props) {

  const { icon, name, detailsLink, href } = props;
  const onLinkClicked = (path) => {
    if (path) {
      if(props.sessionKey) {
        sessionStorage.removeItem(props.sessionKey)
      }
      window.location.href = path;
    }
  }

  return (
    <Card className="card-vertical d-flex flex-column" variant="elevation">
      <CardContent className={`${props.ishomePage && 'pointerDiv pb-0'}`} onClick={() => props.ishomePage ? onLinkClicked(detailsLink) : null}>
        <div className="d-flex justify-content-center">
          <IconHolder icon={icon} viewBox="0 0 25 25"/>
        </div>
        <Typography variant="body1" component="div" align="center" className="mt-2 p-2">
          <Box fontWeight="fontWeightBold" fontSize={15}>
            {name}
          </Box>
        </Typography>
      </CardContent>
      <CardActions className="d-block mt-auto">
        {(props.productKey === 'Term' || props.productKey === 'ABLTC') && <div className="d-flex justify-content-center">
          <Link to="#" className="link-button">
            <Button color="primary" className='link-btn-padding' variant="text" onClick={() => onLinkClicked(href)}>QUICK QUOTE</Button>
          </Link>
        </div>}
        <div className="d-flex justify-content-center">
          <Link to="#" className="link-button">
            <Button color="primary" className='link-btn-padding' variant="text" onClick={() => onLinkClicked(detailsLink)}>DETAILS</Button>
          </Link>
        </div>
      </CardActions>
    </Card>
  )
}

CardVertical.propTypes = {
  icon: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  detailsLink: PropTypes.string,
  onClick: PropTypes.func
}


// WEBPACK FOOTER //
// ./src/components/Common/CardVertical/CardVertical.js